import Request from '../../../../src/core/gd/data/request'

export default class ApiTaskType {

    constructor() {

    }

    static updateSettings(taskTypeId:ID, settings:any) {
        return new Request(this, 'PUT', 'company/'+gd.companyId+'/task-type/'+taskTypeId+'/settings', {
            settings: settings
        });
    }

    static updateTaskType(taskTypeId:ID, payload?: any) {

        return new Request(this,'PUT','company/'+gd.companyId+'/task-type/'+taskTypeId, payload);
    }

    static setTaskTypeSettings(taskTypeId:ID, settings:any) {
        return ApiTaskType.updateSettings(taskTypeId, settings);
        // return new Request(this, 'PUT', 'company/'+organizationId+'/task-type/'+taskTypeId+'/settings', {
        //     settings: settings
        // });
    }
}
